import { Nav, NavItem, NavLink } from "reactstrap";
import { VerticalFormPropsType } from "../../../../Type/FormLayoutType";
import { VARTICAL_WIZARD_TAB_DATA } from "../../../../Data/FormLayout";
import { H6, P } from "../../../../AbstractElements";


const NavComponent = ({ callbackActive,activeTab }: VerticalFormPropsType) => {
  return (
    <Nav className="flex-column header-vertical-wizard">
      {VARTICAL_WIZARD_TAB_DATA.map((data, index) => (
        <NavItem key={index}>
        <NavLink className={activeTab === index+1 ? "active" : ""} onClick={() => {callbackActive(index + 1)}}>
          <div className="vertical-wizard">
            <div className="stroke-icon-wizard">
              <i className={`fa ${data.iconClassName}`} />
            </div>
            <div className="vertical-wizard-content">
              <H6>{data.tittle}</H6>
              <P>{data.tittleInforMation}</P>
            </div>
          </div>
        </NavLink>
      </NavItem>
      ))}
    </Nav>
  );
};

export default NavComponent;
